import { useMutation, useQuery } from '@tanstack/react-query';
import type { DueInspection, MonthlyReport, PhotoUploadResponse, UnpaidResponse } from '@kominiarz/shared';
import { api, apiUpload } from './api';
import { CLIENTS_KEY } from './clientsApi';
import { queryClient } from './queryClient';
import { VISITS_KEY } from './visitsApi';

export function useUnpaid() {
  return useQuery({
    queryKey: [...VISITS_KEY, 'unpaid'],
    queryFn: ({ signal }) => api<UnpaidResponse>('/visits/unpaid', { signal }),
  });
}

export function useDueInspections(days: number) {
  return useQuery({
    queryKey: [...VISITS_KEY, 'due', days],
    queryFn: ({ signal }) => api<{ items: DueInspection[]; days: number }>(`/inspections/due?days=${days}`, { signal }),
  });
}

export function useMonthlyReport(month: string) {
  return useQuery({
    queryKey: [...VISITS_KEY, 'report', month],
    queryFn: ({ signal }) => api<MonthlyReport>(`/reports/monthly?month=${month}`, { signal }),
  });
}

const invalidate = () => {
  void queryClient.invalidateQueries({ queryKey: VISITS_KEY });
  void queryClient.invalidateQueries({ queryKey: CLIENTS_KEY });
};

export function useUploadPhotos(visitId: number) {
  return useMutation({
    mutationFn: (files: File[]) => {
      const form = new FormData();
      for (const f of files) form.append('photos', f, f.name);
      return apiUpload<PhotoUploadResponse>(`/visits/${visitId}/photos`, form);
    },
    onSuccess: invalidate,
  });
}

export function useDeletePhoto() {
  return useMutation({
    mutationFn: (photoId: number) => api<{ ok: true }>(`/photos/${photoId}`, { method: 'DELETE' }),
    onSuccess: invalidate,
  });
}
